import { Grid } from "@material-ui/core";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import GreenSwitch from "../ConfigPayroll/GreenSwitch";
import CheckPermission from "../../helpers/Administradores/Permissions";
import { MenuCourse } from "./MenuCourse";
import { Rating } from "@material-ui/lab";
import { UPDATE_CURSO_SWITCH, GET_ALL_COURSES, GET_CURSOS_IN_PLANINGS } from "../../Querys/querys";
import "../FormacionDesarrollo/css/CourseInfoCard.css";
import LogoBitsDefault from "../../assets/png/LogoBitsDefault.png";
import { useMutation, useQuery } from "@apollo/client";
import { ErrorAlert } from "../../alerts/errorAlert";
export const CourseInfoCard = ({ course }: any) => {
  const [updateCourseSwitch] = useMutation(UPDATE_CURSO_SWITCH, {
    refetchQueries: [{ query: GET_ALL_COURSES }],
  })
  const { data: getConteoCursos } = useQuery(GET_CURSOS_IN_PLANINGS, {
    variables: {
      id: parseInt(course.id)
    }
  })
  const conteo = getConteoCursos?.GET_CURSOS_IN_PLANINGS[0].conteo
  const updateCourseStatus = async (id: any) => {
    if (conteo > 0 && course.status === 'Activo') {
      ErrorAlert({ text: 'No es posible inactivar un curso que se encuentra en un plan de capacitacón' })
    } else {
      await updateCourseSwitch({
        variables:{
          id: id
        }
      })
    }
  };
  return (
    <Grid>
      <Card className="containerCardCourse">
        <CardContent className="containerGeneralCourse">
          <div className="containerInfoImg">
            <div className="containerImagenCourse">
              <img
                alt=""
                className="imgCourse"
                src={course.URL !== "" ? course.URL : LogoBitsDefault}
              />
            </div>
            <div className="containerTypeCourse">
              <span className="typeCourse">
                {/* {course.TypeCourse} */}
                {course.title}
              </span>
            </div>
          </div>
          <div className="infoCardCourse">
            <div className="superiorCourse">
              <div className="containerTitleCourse">
                <span className="titleCourseCard">{course.title}</span>
              </div>
              {CheckPermission("FormacionDesarrollo.Cursos.Activar") && (
                <div className="switchCourseCard">
                  <span className="actCourse">{course.status}</span>
                  <GreenSwitch
                    updatePayrollStatus={updateCourseStatus}
                    id={course.id}
                    status={course.status}
                  />
                </div>
              )}
              {(CheckPermission("FormacionDesarrollo.Cursos.Editar") ||
                CheckPermission("FormacionDesarrollo.Cursos.Eliminar")) && (
                <div className="crudCourseCard">
                  <MenuCourse id={course.id} active={course.status} />
                </div>
              )}
            </div>
            <div className="bussinesDescriptionCourse">
              <span className="bussinesNameCourse">
                Impartido por: {course.bussinesNameInstructor}
                <br />
              </span>
            </div>
            <div className="descriptionContainer">
            <span className="descriptionCourse">
                {course.description}
                <br />
            </span>
            </div>
            <span className="hoursCourse">
                Horas del curso: {course.hours}
            </span>
            {/* <div className="containerDescriptionCourse">
              <span className="descriptionCourse">
                {course.description}
                <br />
              </span>
              <span className="hoursCourse">
                Horas del curso: {course.hours}
              </span>
            </div> */}

            {course.average > 0 ? (
              <div className="star">
                <Rating
                  name="half-rating-read"
                  defaultValue={course.average}
                  precision={0.5}
                  readOnly
                />
              </div>
            ) : (
              <div className="star"></div>
            )}
          </div>
        </CardContent>
      </Card>
    </Grid>
  );
};
